import {isValidElement} from 'rlink-react';
import simpleCheckerFactory from 'rlink-shapes/simpleCheckerFactory';
import isInstanceOf from 'rlink-type-utils/isInstanceOf';

export const element = simpleCheckerFactory('element',
  isValidElement,
  'is not a valid React.Element'
);

function isValidNode (value) {
  if (isValidElement(value) || isInstanceOf(value, Number) || isInstanceOf(value, String) || value === null || value === undefined) {
    return true;
  }
  if (Array.isArray(value)) {
    return value.every(isValidNode);
  }
}

export const node = simpleCheckerFactory('node',
  isValidNode,
  'is not a valid react renderable node'
);



// WEBPACK FOOTER //
// ./lib/rlink-shapes/reactTypes.js